import React, { Component } from "react";
import {
  Regular,
  H1,
  H3,
  XLPrimaryButton,
  XLSecondaryButton,
} from "@worthy-npm/clarity";
import ServicesSection from "./servicesSection";
import DIYSection from "./DIYSection";
import {
  isMobile,
  imageUrl,
  appUrl,
  getItemLink,
} from "helpers/ApplicationHelper";
import CalendlyHelper from "lib/calendly";
import GA from "lib/ga";
import cookie from "react-cookie";
import { connect } from "react-redux";
const EVENTS_LABEL = "from Learn page";

class Experts extends Component {
  constructor(props) {
    super(props);

    this.state = { showCTA: null };

    this.isMobile = isMobile();
    this.DIYref = React.createRef();
  }

  componentDidMount() {
    cookie.save("worthyExperts", true, {
      path: "/",
      expires: new Date(new Date().setYear(new Date().getFullYear() + 1)),
      domain: ".worthy.com",
    });
    if (!this.state.showCTA) {
      if (
        this.props.LastItem ||
        this.props.LastItem === false ||
        !this.props.Session?.isLoggedIn
      ) {
        this.setState({ showCTA: true });
      }
    }
  }

  async scheduleCall(stopAnimation) {
    const ado = this.props.ADO;
    GA.expertsConsultExpert();
    const link = await CalendlyHelper.getCalendlyLinkByValueCategory(this.props.LastItem, ado?.user?.id);
    CalendlyHelper.showPopupWidget(EVENTS_LABEL, link, CalendlyHelper.calendlyParams(this.props.LastItem, ado));
    stopAnimation();
  }

  largeCardsTextExperiment() {
    return [
      {
        type: "consultation",
        title: "Call with a jewelry selling expert",
        bullets: [
          "Build price expectations for your jewelry",
          "Get market insights and selling tips",
          "Discuss online and offline selling options",
          '<span class="text-deleted">$50</span> <b class="bold">Free!</b>',
        ],
        ctaText: "Get Expert Opinion",
        CTAcallBack: (stopAnimation) => {
          GA.expertsConsultExpert();
          CalendlyHelper.showPopupWidget(`from sevices in Learn page`);
          stopAnimation();
        },
      },
      {
        type: "service",
        title: "Managed selling service",
        bullets: [
          "Professional cleaning, studio photos & grading",
          "Personal account executive",
          "Access to large buyer pool",
          "Constant updates",
          'Walk away with <b class="bold">80% of sale price</b>',
        ],
        ctaText: this.props.LastItem ? "Continue Selling" : "Start Selling",
        secondaryCTA: true,
        CTAcallBack: (stopAnimation) => {
          GA.expertsStartSelling();
          const link = this.props.LastItem
            ? getItemLink(this.props.LastItem)
            : "/submit/multiple_jewelry";
          window.location = appUrl(link);
          stopAnimation();
        },
      },
    ];
  }

  trustLogosData() {
    return [
      "experts/logos/International_Gemologist_Institute_Logo.png",
      "experts/logos/GIA_Logo.png",
      "experts/logos/HRD-Antwerp-logo.png",
      "experts/logos/AGS_Labs_Logo.png",
      "experts/logos/Rapaport_Logo.png",
    ];
  }

  render() {
    return (
      <div className="experts">
        <div className="experts-top-section d-flex flex-col flex-align-center text-center">
          <H1
            bold={true}
            text={"Uncover the Value of Your Jewelry"}
            overrideWrapperCSS={{ margin: "0 20px" }}
            overrideCSS={{
              fontFamily: "Playfair Display",
              fontSize: "36px",
              lineHeight: "50px",
            }}
          />
          <Regular
            text={"With the help of Worthy’s knowledge and expertise"}
            overrideWrapperCSS={{ margin: "0 20px" }}
            overrideCSS={{
              marginTop: "15px",
              textDecoration: "underline",
              textDecorationColor: "#FEC5DD",
              textDecorationThickness: "3px",
              textUnderlineOffset: "-2px",
              marginBottom: "80px",
              maxWidth: "500px",
              fontSize: "18px",
            }}
          />
          {this.state.showCTA ? (
            <div className="header-buttons-container d-flex">
              <XLPrimaryButton
                  text={"Get Expert Opinion"}
                  overrideCSS={{
                    backgroundColor: "#2F80ED",
                    borderRadius: "2px",
                    width: "245px",
                    fontSize: "16px",
                    marginRight: this.isMobile ? "0" : "15px",
                    marginBottom: this.isMobile ? "15px" : "0",
                  }}
                  click={this.scheduleCall.bind(this)}
              />
              <XLSecondaryButton
                text={
                  this.props.LastItem ? "Continue Selling" : "Start Selling"
                }
                overrideCSS={{
                  borderRadius: "2px",
                  width: "245px",
                  fontSize: "16px",
                  borderColor: "#2F80ED",
                  color: "#2F80ED",
                }}
                click={(stopAnimation) => {
                  const link = this.props.LastItem
                    ? getItemLink(this.props.LastItem)
                    : "/submit/multiple_jewelry";
                  GA.expertsStartSelling();
                  window.location = appUrl(link);
                  stopAnimation();
                }}
              />
            </div>
          ) : (
            <div className={"loading-buttons"}> </div>
          )}
        </div>
        <div className="trust-logos d-flex">
          {this.trustLogosData().map((partner, i) => {
            return (
              <div key={i} className={"logo d-flex flex-align-center"}>
                <img src={imageUrl(partner)} alt="Our partners" />
              </div>
            );
          })}
        </div>
        <div className="process-section margin-0-auto d-flex flex-col flex-align-center text-center">
          <div className="process-text">
            <H3
              overrideCSS={{ fontFamily: "Playfair Display", fontSize: "26px" }}
              text="How We Help People Sell Their Jewelry"
            />
            <Regular text="For years Worthy has been helping jewelry owners find buyers for their pre-owned diamond jewelry, for maximum value and minimum effort on their part. Our knowledge of the pre-owned jewelry market has  given many sellers the financial boost they needed to make a change." />
          </div>
          <div className="process-image-container d-flex flex-align-center">
            <img
              className="process-image-DT w-100"
              src={imageUrl("experts/processDektop.svg")}
              alt="our process"
            />
            <img
              className="process-image-MB w-100"
              src={imageUrl("experts/processMobile.svg")}
              alt="our process"
            />
          </div>
        </div>
        <div className="cards-container">
          <ServicesSection
            horizScroll={true}
            pageName="Learn"
            data={this.largeCardsTextExperiment()}
          />
          <div ref={this.DIYref}>
            <DIYSection horizScroll={true} eventsLabel={EVENTS_LABEL} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ LastItem, Session, ADO, Item }) => {
  return {
    LastItem,
    Session,
    ADO,
    item: Item
  };
};

export default connect(mapStateToProps)(Experts);
